import { inject, Injectable, Injector } from '@angular/core';
import { ALL_SERVICES } from '@core/services/all.service';

@Injectable({ providedIn: 'root' })
export class GlobalSelectRegistryService {

    private cache = new Map<string, any>();
    private injector = inject(Injector);

    resolve(className: string): any {
        if (this.cache.has(className)) {
            return this.cache.get(className);
        }

        const ServiceClass = ALL_SERVICES[className];

        if (!ServiceClass) {
            throw new Error(`Could not find service "${className}" in GlobalSelect registry. Did you add it to global-select.registry.ts?`);
        }

        const instance = this.injector.get(ServiceClass);
        this.cache.set(className, instance);
        return instance;
    }
}
